// TODO: Clean up component usage and parent settings layout and auth props?

import type { MemberAttribute } from '@di-devs/member-feature-plugin/shared'
import { isProtectedMemberAttribute } from '@di-devs/member-feature-plugin/shared'
import { useBetterFeatureClient } from '@di-devs/utils-fe'
import { message, Switch } from 'antd'
import type { FeatureClient } from '@/config/client'
import { useUpdateMemberAttributes } from '@/queries'
import { COMMONS } from '@/utils'

const MemberAttributeDisplayToggle = ({
	memberAttribute,
	type,
}: {
	memberAttribute: MemberAttribute
	type: 'admin' | 'member'
}) => {
	const { memberAttributeId, isAdminDisplayed, isMemberDisplayed, label, required } =
		memberAttribute
	const isProtectedAttribute = isProtectedMemberAttribute(memberAttribute)
	const reactFeatureClient = useBetterFeatureClient<FeatureClient>()
	const updateMemberAttribute = useUpdateMemberAttributes(reactFeatureClient)

	const toggleIsAdminDisplayed = (checked: boolean) => {
		if (!checked && isMemberDisplayed) {
			return message.error(COMMONS.WARN_MEMBER_ATTR_SET_ADMIN_DISPLAY)
		}
		updateMemberAttribute.mutate({
			memberAttributeId: Number(memberAttributeId),
			data: {
				isAdminDisplayed: checked,
				isMemberDisplayed: !!isMemberDisplayed,
				label,
				required,
			},
		})
	}
	const toggleIsMemberDisplayed = (checked: boolean) => {
		if (checked && !isAdminDisplayed) {
			return message.error(COMMONS.WARN_MEMBER_ATTR_SET_ADMIN_DISPLAY)
		}
		updateMemberAttribute.mutate({
			memberAttributeId: Number(memberAttributeId),
			data: {
				isAdminDisplayed: !!isAdminDisplayed,
				isMemberDisplayed: checked,
				label,
				required,
			},
		})
	}

	// TODO: Debounce functions
	const handleMemberAttributeDisplayToggle = (checked: boolean) =>
		type === 'admin' ? toggleIsAdminDisplayed(checked) : toggleIsMemberDisplayed(checked)

	return (
		<Switch
			checkedChildren='表示'
			unCheckedChildren='非表示'
			checked={type === 'admin' ? isAdminDisplayed : isMemberDisplayed}
			disabled={isProtectedAttribute}
			onChange={handleMemberAttributeDisplayToggle}
		/>
	)
}

export default MemberAttributeDisplayToggle
